import React, { useState, useEffect } from 'react';
import { ListGroup, ListGroupItem, Input, Col, Row } from 'reactstrap';
import IconButton from '@material-ui/core/IconButton';
import { MdAttachFile } from 'react-icons/md';
import { RiDeleteBin6Line } from 'react-icons/ri';

// Redux
import { connect } from 'react-redux';

//Componentes
import CustomModal from '../../../components/modales/customModal';
import AttachCardV2 from '../../../components/cards/attachCardV2';

//Funciones
// import { handleFilesAdd, deleteFile } from '../../../utils/azureStorage/upload';
import { singleFileUploader } from '../../../utils/FirebaseStorage/FirebaseStorage';

import { functionsHttpsCallable } from '../../../utils/FirebaseStorage/firebase';

const actualizarAPE = functionsHttpsCallable('ape_actualizarSolicitudEmpleo');

const mapStateToProps = state => ({
    usuarioActivo: state
})

const ModalPruebasTecnicas = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [gradeHSEQ, setGradeHSEQ] = useState(props.dataApe.calificacionHSEQ ?? 0);
    const [gradeTecnicas, setGradeTecnicas] = useState(props.dataApe.calificacionPruebaTecnica ?? 0);
    const [gradeHabilidadesBlandas, setGradeHabilidadesBlandas] = useState(props.dataApe.calificacionHabilidades ?? 0);
    const [updFile, setUpdFile] = useState([]);

    const fileExist = (filename) => {
        const newArr = props.fileList.filter(file => file.fileName.split('.')[0] == filename)
        return { exists: newArr.length > 0, file: newArr.length > 0 ? newArr[0] : undefined }
    }

    const fileReadyToUpload = (filename) => {
        const newArr = updFile.filter(file => file.key === filename)
        return newArr.length > 0
    }

    const handleUpdate = async () => {
        const body = {
            cod_soli: props.id,
            cod_empr: userData.codigoEmpresa,
            data: {
                grd_hseq: gradeHSEQ,
                grd_tecn: gradeTecnicas,
                grd_habb: gradeHabilidadesBlandas,
                cmp_stat: 'ENTREVISTA'
            }
        }
        const body2 = {
            calificacionHSEQ: gradeHSEQ,
            calificacionPruebaTecnica: gradeTecnicas,
            calificacionHabilidades: gradeHabilidadesBlandas,
            estadoAPE: 'ENTREVISTA'
        }
        await actualizarAPE(body);
        props.updateAPE(body2);
        props.toggle();
        props.toastSuccess('Estado Actualizado!');
    }

    return (
        <React.Fragment>
            <CustomModal
                modal={props.modal}
                toggle={() => props.toggle()}
                buttonTitle={'Actualizar'}
                onClick={() => handleUpdate()}
                buttonLoading={false}
                title={`Actualizar estado a ${props.newState}`}
            >
                <Row>
                    <Col lg='4' md='4' xs='12'>
                        <Row>
                            <AttachCardV2
                                id={'PRUEBAS_HSEQ'}
                                subText={`Prueba HSEQ`}
                                attached={fileReadyToUpload('PRUEBAS_HSEQ') || fileExist('PRUEBAS_HSEQ').exists}
                                file={fileExist(`PRUEBAS_HSEQ`).file}
                                apeId={props.id}
                                fileList={props.fileList}
                                setLoading={(e) => props.setLoading(e)}
                                setFileList={(e) => { props.setFileList(e) }}
                            />
                        </Row>
                        <Row style={{ marginLeft: '5px', marginRight: '5px' }}>
                            <Input placeholder="Calificación" defaultValue={gradeHSEQ ?? 0} min={0} max={100} onChange={(e) => setGradeHSEQ(parseInt(e.target.value))} type="number" step="1" />

                        </Row>
                    </Col>
                    <Col lg='4' md='4' xs='12'>
                        <Row>
                            <AttachCardV2
                                id={'PRUEBAS_TECNICA'}
                                subText={`Prueba Técnica`}
                                attached={fileReadyToUpload('PRUEBAS_TECNICA') || fileExist('PRUEBAS_TECNICA').exists}
                                file={fileExist(`PRUEBAS_TECNICA`).file}
                                apeId={props.id}
                                fileList={props.fileList}
                                setLoading={(e) => props.setLoading(e)}
                                setFileList={(e) => { props.setFileList(e) }}
                            />
                        </Row>
                        <Row style={{ marginLeft: '5px', marginRight: '5px' }}>
                            <Input placeholder="Calificación" defaultValue={gradeTecnicas ?? 0} onChange={(e) => setGradeTecnicas(parseInt(e.target.value))} min={0} max={100} type="number" step="1" />
                        </Row>
                    </Col>
                    <Col lg='4' md='4' xs='12'>
                        <Row>
                            <AttachCardV2
                                id={'PRUEBAS_HB'}
                                subText={`Prueba Habilidades blandas`}
                                attached={fileReadyToUpload('PRUEBAS_HB') || fileExist('PRUEBAS_HB').exists}
                                file={fileExist(`PRUEBAS_HB`).file}
                                apeId={props.id}
                                fileList={props.fileList}
                                setLoading={(e) => props.setLoading(e)}
                                setFileList={(e) => { props.setFileList(e) }}
                            />
                        </Row>
                        <Row style={{ marginLeft: '5px', marginRight: '5px' }}>
                            <Input placeholder="Calificación" defaultValue={gradeHabilidadesBlandas ?? 0} onChange={(e) => setGradeHabilidadesBlandas(parseInt(e.target.value))} min={0} max={100} type="number" step="1" />
                        </Row>
                    </Col>
                </Row>
            </CustomModal>
        </React.Fragment>
    );
}

export default connect(mapStateToProps)(ModalPruebasTecnicas);